import { useIntl } from "react-intl";

import SEO from "../../components/SEO";
import Header from "../../components/Header";
import Slider from "../../components/Slider";
import Breadcrumbs from "../../components/Breadcrumbs";
import Footer from "../../components/Footer";
import CookieAccept from "../../components/CookieAccept";

import Section from "../../components/Section";
import SectionBox from "../../components/SectionBox";
import Panel from "../../components/Panel";
import DeclarationBox from "../../components/DeclarationBox";
import DeclarationBoxItem from "../../components/DeclarationBoxItem";
import DeclarationBoxItemMinutes from "../../components/DeclarationBoxItemMinutes";
import DeclarationModal from "../../components/DeclarationModal";
import BackgroundSection from "../../components/BackgroundSection";
import Tabs from "../../components/Tabs";
import BackButton from "../../components/BackButton";

import Variables from "../../variables/variables.json";

// WITRYNA
import IndexSection1PL from "../../content/witryna/index/section-1_pl.mdx";
import IndexSection2PL from "../../content/witryna/index/section-2_pl.mdx";
import IndexSection3PL from "../../content/witryna/index/section-3_pl.mdx";

export default function HomeLayout(props) {
	const intl = useIntl();

	let Miasto = props.miasto;
	let Podatek = props.podatek;

	return (
		<>
			{/* HEAD */}
			<SEO miasto={Miasto} podatek={Podatek} />

			{/* TOP */}
			<Header miasto={Miasto} />

			<Slider miasto={Miasto} podatek={Podatek} typeHero="slider" />

			{/* SECTION */}

			<Section mdx>
				<IndexSection1PL />
			</Section>

			<Section id="wypelnij-deklaracje" title="sections.wypelnijdeklaracje.title">
				<DeclarationBox miasto={Miasto} center minutes5>
					{Variables.miasta[Miasto].declarationBoxItem[Podatek].map((declarationBoxItem, index) => {
						return (
							<DeclarationBoxItem
								miasto={Miasto}
								podatek={declarationBoxItem.title}
								key={index}
								soon={declarationBoxItem.soon && true}
								noReadMore={declarationBoxItem.noReadMore && true}
							/>
						);
					})}
					{Variables.miasta[Miasto].declarationBoxItem[Podatek].length < 6 && (
						<DeclarationBoxItemMinutes />
					)}
				</DeclarationBox>
				<DeclarationModal miasto={Miasto} />
			</Section>

			<Section primary title="sections.cozyskujesz.title">
				<SectionBox section="cozyskujesz" />
			</Section>

			<Section lightdark mdx>
				<IndexSection2PL />
			</Section>

			<Section primary title="sections.jakkorzystac.title">
				<SectionBox section="jakkorzystac" round />
			</Section>

			<Section lightdark mdx>
				<IndexSection3PL />
			</Section>

			<Section primary title="sections.wynikukalkulacji.title">
				<SectionBox section="wynikukalkulacji" />
			</Section>

			<BackgroundSection
				miasto={Miasto}
				section="lokalnepodatki"
				textAlign="right"
				button="text"
				title
				subtitle
				fillLeftBottom
			/>

			{/* BOTTOM */}

			<Footer miasto={Miasto} />
		</>
	);
}
